import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '../../components/header/Header';
import { Link } from 'react-router-dom';
import RoutingService from '../../services/routingService';
import './Layout.scss';

interface LayoutProps {
    children?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = () => {
    return (
        <div className="layout">
            <header>
                <Header />
            </header>
            
            <main>
                <Outlet />
            </main>

            <footer className='footer'>
                <div className="footer-links">
                    <Link to={RoutingService.getTermsPageRoute()}>Polityka prywatności i Regulamin</Link>
                    <span> · </span>
                    <a href="mailto:kontakt@mediti.pl">kontakt@mediti.pl</a>
                    <span> · </span>
                    <span>© {new Date().getFullYear()} Mediti Sp. z o.o.</span>
                </div>
            </footer>
        </div>
    );
};

export default Layout;